// FT-191: синхронизация вкладок общего компьютера и заморозка persisted-state.
//
// Вкладки одного браузера делят localStorage: блокировка, разблокировка и смена сотрудника
// рассылаются им явным событием через ключ DEVICE_EVENT_KEY (storage-событие видят все вкладки,
// кроме записавшей). Мутации стора между вкладками блокировку не переносят — у
// createMutationsSharer свой список, и мутации deviceLock в нём нет намеренно.
//
// Заморозка нужна при смене сотрудника: с момента смены вкладка не имеет права ни писать
// `vuex` в localStorage, ни рассылать мутации — иначе состояние прежнего сотрудника вернётся
// в общее хранилище после очистки. Флаг живёт в памяти вкладки и переживает её до перезагрузки.

export const DEVICE_EVENT_KEY = "rp_device_event";
const TYPES = [ "lock", "unlock", "switch", "switch_ready" ];

let frozen = false;

export function freezePersistence() {
  frozen = true;
}

export function isPersistenceFrozen() {
  return frozen;
}

// Только для тестов: модульный флаг иначе протекает между примерами.
export function unfreezePersistenceForTests() {
  frozen = false;
}

// Эпоха делает каждое событие уникальным: два одинаковых lock подряд без неё дали бы ту же
// строку, и второе storage-событие не сработало бы.
export function emitDeviceEvent(type, { userId } = {}, storage = window.localStorage) {
  const epoch = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  try {
    storage.setItem(DEVICE_EVENT_KEY, JSON.stringify({ type, userId: userId ?? null, epoch, at: Date.now() }));
  } catch (e) {
    // хранилище недоступно — синхронизация вкладок невозможна, блокировка этой вкладки остаётся
  }
}

// null — всё, что не является событием протокола: чужой ключ, удаление ключа (newValue null —
// удаление не трактуется как lock), битый JSON, неизвестный тип. Своё событие вкладка не получает:
// storage-событие приходит только другим вкладкам.
export function parseDeviceEvent(storageEvent) {
  if (!storageEvent || storageEvent.key !== DEVICE_EVENT_KEY || !storageEvent.newValue) return null;
  let data;
  try {
    data = JSON.parse(storageEvent.newValue);
  } catch (e) {
    return null;
  }
  if (!data || TYPES.indexOf(data.type) === -1) return null;
  return { type: data.type, userId: data.userId ?? null, epoch: data.epoch };
}
